export default "__VITE_ASSET__ugoC7C11__"